(() => {
  function initReview() {
    const section = document.querySelector('[data-md-review]');
    if (!section) return;
    const shell = section.querySelector('[data-md-review-shell]');
    const frame = section.querySelector('[data-md-review-frame]');
    const message = section.querySelector('[data-md-review-message]');
    if (!shell || !frame || !message) return;
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token || !/^[A-Za-z0-9_-]{20,160}$/.test(token)) {
      shell.hidden = true;
      message.hidden = false;
      return;
    }
    frame.src = 'https://mellowden-approval-backend-production.up.railway.app/review/' + encodeURIComponent(token);
    shell.hidden = false;
    message.hidden = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReview, { once: true });
  else initReview();
})();